import { bootstrapConsentMode } from "./lib/tracking";

// Registra Google Consent Mode v2 com analytics_storage='denied' por padrão.
// Sentry e GA4 só sobem após o ConsentProvider validar o consentimento.
bootstrapConsentMode();

import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
